export default __webpack_public_path__ + "static/media/image-headphones.fbd401d9.png";